import { pageIsDark } from '../snapshot';

// A widget root on the shared library (facts model widget_ui, requirements 206, 209): `data-jui-portal` keeps library
// menus, popovers and toasts inside it (П305 — isOwn and skipOnShot see them as the widget's), `data-theme` carries the
// theme the page shows, so the library tokens scoped under `.jaiora-bugs` follow the host and not the OS alone.

const roots = new Set<HTMLElement>();
let observer: MutationObserver | null = null;
let media: MediaQueryList | null = null;

function syncAll(): void {
  const theme = pageIsDark() ? 'dark' : 'light';
  for (const el of roots) if (el.dataset.theme !== theme) el.dataset.theme = theme;
}

function watch(): void {
  if (observer || typeof MutationObserver === 'undefined') return;
  observer = new MutationObserver(syncAll);
  const options = { attributes: true, attributeFilter: ['class', 'style', 'data-theme'] };
  observer.observe(document.documentElement, options);
  if (document.body) observer.observe(document.body, options);
  media = window.matchMedia?.('(prefers-color-scheme: dark)') ?? null;
  media?.addEventListener?.('change', syncAll);
}

function unwatch(): void {
  observer?.disconnect();
  observer = null;
  media?.removeEventListener?.('change', syncAll);
  media = null;
}

/** Marks `el` as a widget root on the library; the returned function takes the marks off. */
export function markJuiRoot(el: HTMLElement): () => void {
  const hadPortal = el.hasAttribute('data-jui-portal');
  const hadTheme = el.dataset.theme;
  el.setAttribute('data-jui-portal', '');
  roots.add(el);
  watch();
  syncAll();
  return () => {
    roots.delete(el);
    if (!hadPortal) el.removeAttribute('data-jui-portal');
    if (hadTheme === undefined) delete el.dataset.theme;
    else el.dataset.theme = hadTheme;
    if (roots.size === 0) unwatch();
  };
}
